<template>
  <section class="max-w-620px mx-auto">
    <RouterLink to="./" class="parmigiano opacity-72 hover:text-blue-600">
      / Календарь событий
    </RouterLink>

    <div class="flex my-4">
      <c-tag>{{ It.type.name }}</c-tag>
    </div>

    <h1 class="cheddar mb-4 font-init">
      {{ It.title }}
    </h1>
    <div class="mb-4 flex items-center feta">
      <span class="mr-2 opacity-48" v-if="It.organizer">{{
        `${It.organizer}, `
      }}</span>
      <span class="mr-2 opacity-48">{{ It.age_restricted }}</span>
    </div>
    <div class="my-4 flex <md:flex-wrap gap-x-4">
      <div class="flex-shrink-0 flex items-center">
        <c-icon-base class="mr-2">
          <path
            d="M5 8c-.55228 0-1 .44771-1 1v1c0 .5523.44772 1 1 1h2c.55228 0 1-.4477 1-1V9c0-.55228-.44772-1-1-1H5Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 0c.55228 0 1 .447715 1 1h4c0-.552285.4477-1 1-1s1 .447715 1 1h1c1.6569 0 3 1.34315 3 3v9c0 1.6569-1.3431 3-3 3H3c-1.65685 0-3-1.3431-3-3V4c0-1.65685 1.34315-3 3-3h1c0-.552285.44772-1 1-1ZM3 3c-.55228 0-1 .44772-1 1v1h10c.5523 0 1 .44772 1 1s-.4477 1-1 1H2v6c0 .5523.44772 1 1 1h10c.5523 0 1-.4477 1-1V4c0-.55228-.4477-1-1-1H3Z"
          />
        </c-icon-base>
        <span class="opacity-72">
          {{
            It.started_at && `с ${$dayjs(It.started_at).format("D MMMM HH:mm")}`
          }}
          {{
            It.ending_at &&
            ` - по ${$dayjs(It.ending_at).format("D MMMM HH:mm")}`
          }}
        </span>
      </div>
      <div class="flex items-center">
        <c-icon-base class="mr-2">
          <path
            d="M10.7164 2.05232c.6377-.1965 1.2836.2803 1.2836.94761 0 .55229.4477 1.00004 1 1.00004s1-.44772 1-1C14 1.29287 12.5977 0 11 0c-.2836.0000314-.5799.0508498-.8725.141005L2.8221 2.39207C1.14452 2.909 0 4.45929 0 6.21471v6.78519c0 1.6569 1.34315 3 3 3h11c1.1046 0 2-.8954 2-2V6.99993c0-1.10457-.8954-2-2-2H4c-.55228 0-1 .44772-1 1 0 .55229.44772 1 1 1h10v6.99997H3c-.55228 0-1-.4477-1-1V6.21471c0-.87771.57226-1.65285 1.41105-1.91132l7.30535-2.25107Z"
          />
          <path
            d="M13 10.5c0 .8284-.6716 1.5-1.5 1.5s-1.5-.6716-1.5-1.5c0-.82846.6716-1.50003 1.5-1.50003S13 9.67154 13 10.5Z"
          />
        </c-icon-base>
        <span class="opacity-72">{{
          It.price_from ? `от ${It.price_from} ₽` : "Бесплатно"
        }}</span>
      </div>
    </div>

    <picture class="block aspect-10/16 overflow-hidden my-6" v-if="currImg">
      <div
        class="object-fill min-h-full min-w-full bg-no-repeat bg-cover bg-center blur-10 filter"
        :style="{
          backgroundImage: `url(${currImg})`,
        }"
      />
      <div
        class="object-fill min-h-full min-w-full bg-no-repeat bg-contain bg-center z-1 absolute inset-0"
        :style="{
          backgroundImage: `url(${currImg})`,
        }"
      />
    </picture>
    <div class="grid lg:grid-cols-4 grid-cols-3 gap-8 my-8">
      <picture
        v-for="(img, idx) in [...It.images, It.image_previews.small]"
        :key="idx"
        class="block aspect-10/16 cursor-pointer"
        @click="currImg = img"
        v-show="img"
      >
        <img
          class="object-cover rounded-8px"
          style="object-position: top center"
          :src="img"
          alt
        />
      </picture>
    </div>
    <dl v-if="It.online_urls && It.online_urls.length" class="mt-5 mb-5">
      <dd
        class="mt-1 parmigiano opacity-72"
        v-for="(video, index) in It.online_urls"
      >
        <a :href="video" target="_blank" class="links">Трансляция события</a>
      </dd>
    </dl>
    <article
      class="prose opacity-72"
      style="text-align: justify; word-wrap: break-word"
      v-html="It.description.replace(/\n/g, '<br>')"
    />
    <ul v-if="It.organizer_phone" class="my-9">
      <li>
        Телефон для справок:
        <a :href="'tel:' + It.organizer_phone">{{ It.organizer_phone }}</a>
      </li>
    </ul>
    <!-- <ul v-if="It.venues.length" class="my-9">
      <li v-for="item in It.venues" :key="item.id">
        {{ item.title }}, {{ item.address }}
      </li>
    </ul> -->

    <div class="my-9">
      <r-map
        v-if="It.venues.length"
        @mapInit="initMap"
        @markersWasAdd="markersWasAdd"
        :zoom="zoom"
      >
        <ymap-marker
          v-for="(marker, idx) in ymapMarkers()"
          :key="idx"
          :marker-id="idx"
          :coords="marker.center"
          :hint-content="marker.address"
          :icon="{
            layout: 'default#image',
            imageHref:
              'https://storage.rosatom.city/platform-test/vue-culture/map/marker.svg',
          }"
          :options="{ hideIconOnBalloonOpen: false }"
          :balloon-template="balloonTemplate(marker)"
        />
      </r-map>
    </div>
    <div class="my-4">
      <ul class="my-3 font-title">
        <li>Место и время проведения</li>
      </ul>
      <div @click="updateCalendar(It.sessions)">
        <r-date-picker
          :is-input="true"
          label="Дата мероприятия"
          class="cleaning_date flex"
          :value="selectedDate"
          fill="rocky"
          click-close
          @input="(val) => changeDate(val)"
          :startDate="
            It.started_at ? $dayjs(It.started_at).format('YYYY-MM-DD') : null
          "
          :endDate="
            It.started_at
              ? $dayjs(It.ending_at).add(1, 'day').format('YYYY-MM-DD')
              : null
          "
        />
      </div>
      <div v-for="(item, idx) in sessions" v-if="item">
        <ul class="mt-6 mb-1 font-name">
          <li>
            {{ sessionsTitle[idx] }}
          </li>
        </ul>
        <ul class="mb-6 font-adress">
          <li>
            {{ sessionsAdress[idx] }}
          </li>
        </ul>
        <div class="mb-10 flex flex-wrap">
          <div class="flex-1 time mb-5 mr-5" v-for="(value, id) in item">
            {{ value.formatHM }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex items-center mb-8">
      <!--      <CIconBase>-->
      <!--        <path-->
      <!--          d="M5 2.00966c-.55228 0-1 .44987-1 1.00482V13.9866l2.75061-2.2111c.73044-.5872 1.76834-.5872 2.49878 0L12 13.9866V3.01448c0-.55495-.4477-1.00482-1-1.00482H5ZM2 3.01448C2 1.34963 3.34315 0 5 0h6c1.6569 0 3 1.34963 3 3.01448V13.9866c0 1.6851-1.9399 2.6219-3.2494 1.5692L8 13.3447l-2.75061 2.2111C3.93986 16.6085 2 15.6717 2 13.9866V3.01448Z"-->
      <!--        />-->
      <!--      </CIconBase>-->
      <!--      <a href="#" class="ml-6px text-rocky">В избранное</a>-->
    </div>

    <div class="flex <md:flex-wrap">
      <c-social-sharing
        class="md:w-4/6"
        :title="It.title"
        :description="It.description.replace(/<[^>]+>/g, '')"
      />
      <div class="ml-6" v-if="It.url">
        <h6 class="feta opacity-48 mb-2">Источник</h6>
        <a :href="It.url" target="_blank" class="link">Источник</a>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import IconBase from "@/components/IconBase.vue";
import SocialSharing from "@/components/SocialSharing.vue";
import Tag from "@/components/Tag.vue";
import RMap from "../components/RirMap";

export default {
  components: {
    CIconBase: IconBase,
    CTag: Tag,
    CSocialSharing: SocialSharing,
    RMap,
  },
  props: {
    It: {
      type: Object,
    },
  },
  data() {
    return {
      currImg: this.It.image_previews.medium,
      map: null,
      zoom: 13,
      selectedDate: null,
      selectedDateFrom: null,
      boolMap: true,
      sessions: [],
      sessionsTitle: [],
      sessionsAdress: [],
      months: [
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь",
      ],
      link: [],
      button: null,
    };
  },
  mounted() {
    const _this = this;
    this.changeDate(this.getActualSessionDate(this.It.sessions));
    _this.sessions = [];
    this.It.sessions.map((item) => {
      if (_this.selectedDate == _this.dateFilter(item.datetime)) {
        _this.sessions[item.venue.id] = [];
        _this.sessionsTitle[item.venue.id] = [];
        _this.sessionsAdress[item.venue.id] = [];
      }
    });
    this.It.sessions.map((item) => {
      if (_this.selectedDate == _this.dateFilter(item.datetime)) {
        _this.sessionsTitle[item.venue.id] = item.venue.title;
        _this.sessionsAdress[item.venue.id] = item.venue.address;

        _this.sessions[item.venue.id].push({
          formatHM: _this.formatHM(item.datetime),
        });
      }
    });
  },
  methods: {
    
    updateCalendar(events) {
      console.log("updateCalendar");
      // Получаем текущий месяц и год из заголовка календаря
      const monthTitle = document
        .querySelector(".RDatePicker__title.month")
        ?.textContent?.trim();
      const yearTitle = document
        .querySelector(".RDatePicker__title.year")
        ?.textContent?.trim();

      // Преобразуем название месяца в числовой формат (0-11)
      const months = {
        Январь: 0,
        Февраль: 1,
        Март: 2,
        Апрель: 3,
        Май: 4,
        Июнь: 5,
        Июль: 6,
        Август: 7,
        Сентябрь: 8,
        Октябрь: 9,
        Ноябрь: 10,
        Декабрь: 11,
      };
      const targetMonth = months[monthTitle];
      const targetYear = parseInt(yearTitle, 10);

      // Собираем разрешенные дни из событий
      const allowedDays = events
        .map((event) => {
          const date = new Date(event.datetime);
          return {
            month: date.getMonth(),
            year: date.getFullYear(),
            day: date.getDate(),
          };
        })
        .filter(
          (date) => date.month === targetMonth && date.year === targetYear
        )
        .map((date) => date.day);

      // Блокируем все незапланированные даты
      const cells = document.querySelectorAll(
        ".RDatePicker__column:not(.block)"
      );
      cells.forEach((cell) => {
        const day = parseInt(cell.textContent.trim(), 10);
        if (!allowedDays.includes(day)) {
          cell.classList.add("block");
        }
      });
      this.initCalendarHandlers();
    },
    initCalendarHandlers() {
      const navigation = document.querySelector(".RDatePicker__navigation");
      if (!navigation) return;

      // Вешаем обработчики на все кнопки навигации
      const buttons = navigation.querySelectorAll("button");
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(() => {
            this.updateCalendar(this.It.sessions);
          }, 50);
        });
      });
    },
    ymapMarkers() {
      return this.It.venues.reduce(
        (acc, it) =>
          acc.concat({
            ...it,
            img: this.It.image_previews.small,
          }),
        []
      );
    },
    formatHM(date) {
      date = new Date(date);
      let HH = date.getHours();
      if (HH < 10) HH = `0${HH}`;
      let mm = date.getMinutes();
      if (mm < 10) mm = `0${mm}`;

      return `${HH}:${mm}`;
    },
    formatDate(date) {
      date = new Date(date);
      let dd = date.getDate();
      if (dd < 10) dd = `0${dd}`;
      let mm = date.getMonth() + 1;
      if (mm < 10) mm = `0${mm}`;
      const yy = date.getFullYear();
      this.selectedDate = `${yy}-${mm}-${dd}`;
      this.selectedDateFrom = `${dd}.${mm}.${yy}`;
    },
    getActualSessionDate(events) {
      const currentDate = new Date();
      // Сортируем события по дате в порядке возрастания
      const sortedEvents = [...events].sort(
        (a, b) =>
          new Date(a.datetime).getTime() - new Date(b.datetime).getTime()
      );

      // Ищем первый сеанс, который еще не наступил
      for (const event of sortedEvents) {
        const eventDate = new Date(event.datetime);
        if (eventDate >= currentDate) {
          return event.datetime;
        }
      }

      // Если все сеансы прошли, возвращаем дату последнего
      if (sortedEvents.length > 0) {
        return sortedEvents[sortedEvents.length - 1].datetime;
      }

      return null; // Возвращаем null, если событий нет
    },
    updateCalendar(events) {
      console.log("updateCalendar");
      // Получаем текущий месяц и год из заголовка календаря
      const monthTitle = document
        .querySelector(".RDatePicker__title.month")
        ?.textContent?.trim();
      const yearTitle = document
        .querySelector(".RDatePicker__title.year")
        ?.textContent?.trim();

      // Преобразуем название месяца в числовой формат (0-11)
      const months = {
        Январь: 0,
        Февраль: 1,
        Март: 2,
        Апрель: 3,
        Май: 4,
        Июнь: 5,
        Июль: 6,
        Август: 7,
        Сентябрь: 8,
        Октябрь: 9,
        Ноябрь: 10,
        Декабрь: 11,
      };
      const targetMonth = months[monthTitle];
      const targetYear = parseInt(yearTitle, 10);

      // Собираем разрешенные дни из событий
      const allowedDays = events
        .map((event) => {
          const date = new Date(event.datetime);
          return {
            month: date.getMonth(),
            year: date.getFullYear(),
            day: date.getDate(),
          };
        })
        .filter(
          (date) => date.month === targetMonth && date.year === targetYear
        )
        .map((date) => date.day);

      // Блокируем все незапланированные даты
      const cells = document.querySelectorAll(
        ".RDatePicker__column:not(.block)"
      );
      cells.forEach((cell) => {
        const day = parseInt(cell.textContent.trim(), 10);
        if (!allowedDays.includes(day)) {
          cell.classList.add("block");
        }
      });
      this.initCalendarHandlers();
    },
    initCalendarHandlers() {
      const navigation = document.querySelector(".RDatePicker__navigation");
      if (!navigation) return;

      // Вешаем обработчики на все кнопки навигации
      const buttons = navigation.querySelectorAll("button");
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(() => {
            this.updateCalendar(this.It.sessions);
          }, 50);
        });
      });
    },
    dateFilter(datetime) {
      this.link = [];
      const date = new Date(datetime);
      let dd = date.getDate();
      let link = document.querySelectorAll(".RDatePicker__column");
      link = Array.from(link).filter((e) => dd == e.textContent);

      if (dd < 10) dd = `0${dd}`;
      let mm = date.getMonth() + 1;

      let linkM = document.querySelectorAll(".month");
      linkM = Array.from(linkM).filter((e) =>
        new RegExp(this.months[date.getMonth()]).test(e.textContent)
      );

      if (mm < 10) mm = `0${mm}`;
      const yy = date.getFullYear();

      let linkY = document.querySelectorAll(".year");
      linkY = Array.from(linkY).filter((e) =>
        new RegExp(yy).test(e.textContent)
      );

      if (linkM.length > 0 && linkY.length > 0) {
        this.link = link;
      }

      return `${yy}-${mm}-${dd}`;
    },
    clickDate() {
      const link = document.querySelectorAll(".RDatePicker__column");
      for (const a of link) {
        a.classList.remove("archive");
      }

      const _this = this;
      this.It.sessions.map((item) => {
        _this.dateFilter(item.datetime);
        for (const a of _this.link) {
          a.classList.add("archive");
        }

        const link = document.querySelectorAll(".otherMonth");
        for (const a of link) {
          a.classList.remove("archive");
        }
      });

      _this.button = document.querySelectorAll(".RButtonAction");
      if (_this.button) {
        for (const btn of _this.button) {
          btn.addEventListener(
            "click",
            () => {
              _this.clickDate();
            },
            { once: true }
          );
        }
      }
    },
    changeDate(date) {
      const _this = this;
      this.formatDate(date);
      _this.sessions = [];
      this.It.sessions.map((item) => {
        if (_this.selectedDate == _this.dateFilter(item.datetime)) {
          _this.sessions[item.venue.id] = [];
          _this.sessionsTitle[item.venue.id] = [];
          _this.sessionsAdress[item.venue.id] = [];
        }
      });
      this.It.sessions.map((item) => {
        if (_this.selectedDate == _this.dateFilter(item.datetime)) {
          _this.sessionsTitle[item.venue.id] = item.venue.title;
          _this.sessionsAdress[item.venue.id] = item.venue.address;

          _this.sessions[item.venue.id].push({
            formatHM: _this.formatHM(item.datetime),
          });
        }
      });
    },
    markersWasAdd() {
      this.centeredMap();
    },
    initMap(e) {
      this.map = e;
    },
    centeredMap() {
      if (this.map && this.ymapMarkers.length > 0) {
        const pointsList = [];
        if (this.ymapMarkers.length > 0) {
          this.ymapMarkers.forEach((item) => {
            if (item?.center?.length > 0) {
              pointsList.push(item.center);
            }
          });
        }
        this.$nextTick(() => {
          if (pointsList.length > 0) {
            this.map.setBounds(this.map.geoObjects.getBounds());
            if (this.map.getZoom() > 17) {
              this.map.setZoom(17);
              this.zoom = 17;
            }
          }
        });
      }
    },
    balloonTemplate(obj) {
      return `
      <div class="block w-72">
        <picture class="block aspect-10/16">
          <img class="object-cover" src="${obj.img}" />
        </picture>
        <div class="p-4">
          <h3 class="bryndza mb-1">${obj.title}</h3>
          <p>${obj.address}</p>
        </div>
      </div>`;
    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 524px) {
  .font-init {
    font-size: 26px !important;
    line-height: 22px !important;
  }
}
.font-title {
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 32px;
  color: #04153e;
}
.cleaning_date {
  ::v-deep .r-input {
    background: transparent;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    padding: 0;
    height: 34px;

    &__body {
      padding: 0;
      flex: none;
      margin-left: 6px;
    }

    &__input {
      height: auto;
    }

    &__label {
      transform: translateY(1px);
      color: #3d75e4 !important;
      position: relative;
      left: unset;
      top: unset;
      font-size: 16px;
    }

    input {
      display: none;
    }

    &__after {
      position: relative;
      margin-left: 0;

      i {
        opacity: 1;
      }

      a:after {
        content: "";
        position: absolute;
        height: 100%;
        width: 110px;
        left: 100%;
        z-index: 9;
      }

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
}
.font-name {
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #04153e;
}
.font-adress {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #04153e;
}
.time {
  flex-direction: row;
  align-items: center;
  padding: 8px 22px;
  gap: 10px;
  max-width: 80px;
  height: 32px;
  background: #f6f9fe;
  border-radius: 24px;
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #04153e;
  opacity: 0.72;
}
</style>
<style>
/* .RDatePicker__column {
  color: rgba(9, 31, 82, 0.16) !important;
}
.RDatePicker__column.active {
  color: #fff !important;
}
.archive {
  color: #113079 !important;
}
.block {
  display: flex !important;
} */
.RDatePicker__column.block {
  display: flex !important;
}
</style>
